import Axios, {
  AxiosRequestConfig,
  Method,
  AxiosInstance,
  AxiosResponse,
} from 'axios';
import { API2_HOST, WS2_HOST } from '@bfe/by-dynamic-domain';
import { GatewayResponse } from './types';
import { error, genUrl, getHeaders, transformResponse } from './utils';
import { getUserToken, removeToken, setToken } from '../token';
import { showComplianceWall } from '../uniframe';
export type { GatewayResponse };
export { getHeaders };

export interface WebReq {
  params?: { [index: string]: any };
  forms?: any;
}

export interface CustomAxiosRequestConfig extends AxiosRequestConfig {
  contentType?: 'application/json';
}

export interface Headers {
  'Content-Type': string;
}

export interface Options {
  headers?: Headers;
  config?: CustomAxiosRequestConfig;
}

export interface CustomWebapiConfig {
  showOriginData?: boolean;
}

export class Webapi {
  private axios: AxiosInstance;

  private reqInterceptors: number;

  private resInterceptors: number;

  constructor(options: Options) {
    this.axios = Axios.create(options.config);
    this.reqInterceptors = this.axios.interceptors.request.use(
      async (config: any) => {
        // 打上请求时间

        config.requestTime = Date.now();

        config.headers = {
          ...getHeaders(config),
          ...config.headers,
        };
        // 用户 Token
        const token = await getUserToken();
        if (token) {
          config.headers.usertoken = token;
        }

        return config;
      },
      (err) => error(err)
    );
    this.resInterceptors = this.axios.interceptors.response.use(
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      (res: AxiosResponse<GatewayResponse>) => {
        const data = transformResponse(res);

        // 登录状态有啥问题时直接跳转到登录页
        if ([10007, 33003, 10009, 30000].includes(data.ret_code)) {
          removeToken();
          // reportToken('ajax_error', res);
        }

        // 续 Token
        if (data.token) {
          setToken(data.token);
          // reportToken('ajax_set', res);
        }

        // 合规墙 - （用户没有KYC || 本地区不支持此服务）就弹出相关弹窗
        if (data.ret_code === 10024) {
          const { ret_code: retCode, result } = data;
          // 阻止toast弹出信息
          data.message = '';
          showComplianceWall(retCode, result);
        }

        return { data };
      },
      (err) => {
        // reportError(err.response ? err.response : err, err.message);
        return error(err);
      }
    );
  }

  get<T>(url: string, params?: WebReq['params'], config?: AxiosRequestConfig) {
    return this.api<T>(url, { params }, 'get', config);
  }

  post<T>(url: string, forms?: WebReq['forms'], config?: AxiosRequestConfig) {
    return this.api<T>(url, { forms }, 'post', config);
  }

  api<T>(
    url: string,
    req: WebReq,
    method: Method = 'get',
    config?: AxiosRequestConfig
  ): Promise<GatewayResponse<T>> {
    if (url.match(/:/) || method.match(/get/i)) {
      // 如果路由是带挂参的，先看params再看forms
      url = genUrl(url, req.params || req.forms);
    }
    method = method.toLocaleLowerCase() as Method;

    // console.log('API2_HOST', API2_HOST);
    // console.log('WS2_HOST', WS2_HOST);

    switch (method) {
      case 'get':
        return this.axios.get(url, config).then((res) => res.data);

      case 'post':
        return this.axios
          .post(url, req.forms || req.params, config)
          .then((res) => res.data);
      default:
        return this.axios.get(url, config).then((res) => res.data);
    }
  }
}

export const webapi = new Webapi({
  config: {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
    baseURL: process.env.NODE_ENV === 'development' ? process.env.BYBIT_API2_HOST : API2_HOST,
    timeout: 30000,
    withCredentials: true,
  },
});
